import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import axios from 'axios';
import Loader from '../../../Loader';

class Question3 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			val: '',
			data: ''
		};

		this.sendFeedback = this.sendFeedback.bind(this);
		this.getSocialLinks = this.getSocialLinks.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);

		this.getSocialLinks();

	}

	render() {
		if (this.state.data) {
			let shareLinks = this.state.data['share-options'];
			let myArr = Object.entries(shareLinks);
			var indents = myArr.map(function (item, i) {
				return (
					<li key={i}><a href={item[1].value} target="blank">{item[1].key}</a></li>
				);
			});




			return (
				<div className="feedback-question">
					<h2>{this.props.t('Question3-Wil je ons helpen door Framefit te delen met jouw fietsvrienden?')}</h2>
					<p>{this.props.t('Question3-Framefit is een nieuw en')}.</p>
					<p>{this.props.t('Question3-Je helpt ons enorm door Framefit aan te raden bij jouw fietsvrienden')}.</p>
					<p>{this.props.t('Question3-Klik op de links hieronder om Framefit te delen')}.</p>
					<div className="input-container row">
						<div className="col">
							<ul>
								{indents}
								<li>{this.props.t('Question3-Deel de link van onze promovideo')}: <a href="https://www.youtube.com/watch?v=MYZB4aZs3p4&feature=youtu.be" target="blank">{this.props.t('Question3-Bekijk onze promovideo')}</a><pre>https://youtu.be/MYZB4aZs3p4</pre></li>
							</ul>
						</div>
					</div>
					<div className="button-container row">
						<div className="col">
							<button className="btn btn-primary col" onClick={() => { this.sendFeedback() }}>{this.props.t('Question3-Klaar met delen')}</button>
						</div>
					</div>
				</div>
			)
		} else {
			return <Loader />;
		}

	}

	getSocialLinks = function () {
		let url = "/feedback/share-options";
		axios.get(url).then(response => {
			this.setState({ data: response.data });
		}).catch(response => {
			console.log('error');
		})
	}

	sendFeedback = function () {

		this.props.nextQuestion(3);

	}

	closeFeedback = function () {
		this.props.nextQuestion(6);
	}


}

export default withTranslation('result')(Question3);
